import { atomWithReset } from 'jotai/utils';

import { RegisterParams } from 'src/types/guest';

export const state = atomWithReset<RegisterParams>({
  joinStart: false,
  store: null,
  duty: 'null',
  responsibility: null,
  role: null,
  name: {
    first: '',
    last: '',
    fullName: '',
  },
  profile: null,
  allowPush: true,
  code: '',
  loginId: '',
  loginPw: '',
  loginRepw: '',
  terms: {
    PRIVACY_STATEMENT: null,
    COLLECTION_AND_USE: null,
    PRIVACY_CONSIGNMENT: null,
    RULES_OF_WITHDRAWAL: null,
    TERMS_OF_SERVICE: null,
  },
  socialLink: {
    type: '',
    name: '',
    token: '',
    socialType: '',
    userloginLanguage: '',
  },
  socialId: '',
  dutyName: '',
  responsibilityName: '',
  option: {
    pushToken: '',
    pushLanguage: '',
    notificationed: '',
  },
});

export const codeInputBrand = atomWithReset<{
  companyName: string;
  code: string;
  name: string;
  brandType: string;
  logo: string;
  socialAuth: boolean;
  social: any[];
  idp: boolean;
  authUrl: string | null;
  duty?: {
    value: string;
    text: string;
    translate: string;
    name?: string;
    id?: string | number;
  };
  responsibility?: {
    value: string;
    text: string;
    translate: string;
    name?: string;
    id?: string | number;
  };
  responsibilityCode?: string;
}>({
  companyName: '',
  code: '',
  name: '',
  brandType: '',
  logo: '',
  socialAuth: false,
  social: [],
  idp: false,
  authUrl: null,
  duty: {
    value: '',
    text: '',
    translate: '',
  },
  responsibility: {
    value: '',
    text: '',
    translate: '',
  },
  responsibilityCode: '',
});
